import React from "react";
import { Building, ThumbsUp, Award, CheckCircle } from "lucide-react";
import realEstateImg from "../../Files/About-us-home-first-brickimage.png";

const HomeAboutUs = () => {
    return (
        <section className="hob-aboutus-section">
            <div className="hob-aboutus-container">
                {/* Left Content */}
                <div className="hob-aboutus-left">
                    <h2 className="hob-aboutus-heading">About Get Propertys</h2>
                    <p className="hob-aboutus-text">
                        <strong>Get Propertys</strong> is a reliable name in the real estate and insurance space with over 5 years of dedicated service. We provide transparent and personalized property solutions across Mumbai and surrounding regions. Whether you're buying, selling, renting, or investing, our team ensures a seamless, compliant, and result-driven experience.
                        <br /><br />
                        With a MAHA RERA registration and strong industry knowledge, we specialize in helping clients make confident decisions — from local residents to NRI investors — by offering complete support from search to documentation.
                    </p>

                    <ul className="hob-aboutus-list">
                        <li><CheckCircle size={20} /> Residential & Commercial Buy/Sell/Rent</li>
                        <li><CheckCircle size={20} /> Property Deals for Investors & Businesses</li>
                        <li><CheckCircle size={20} /> Legal Guidance & Document Assistance</li>
                        <li><CheckCircle size={20} /> Land Acquisition & Off-Market Deals</li>
                    </ul>
                </div>

                {/* Right Side Image & Stats */}
                <div className="hob-aboutus-right">
                    <div className="hob-aboutus-image-wrapper">
                        <img
                            src={realEstateImg}
                            alt="Get Propertys Real Estate"
                            className="hob-aboutus-image"
                        />

                        {/* Floating Stats */}
                        <div className="hob-aboutus-float hob-aboutus-top-right">
                            <div className="hob-aboutus-flex">
                                <Building size={18} />
                                <span>5+ Years</span>
                            </div>
                            <p className="hob-aboutus-float-desc">
                                Of expertise in real estate & insurance.
                            </p>
                        </div>

                        <div className="hob-aboutus-float hob-aboutus-bottom-right">
                            <div className="hob-aboutus-flex">
                                <ThumbsUp size={18} />
                                <span>2K+ Clients</span>
                            </div>
                            <p className="hob-aboutus-float-desc">
                                Served with integrity and results.
                            </p>
                        </div>

                        <div className="hob-aboutus-float hob-aboutus-center-float">
                            <div className="hob-aboutus-flex">
                                <Award size={18} />
                                <span>End-to-End Services</span>
                            </div>
                            <p className="hob-aboutus-float-desc">
                                Real estate, land, legal, and more.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HomeAboutUs;
